var _defs, _use;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPartlyCloudyDay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "c",
    viewBox: "0 0 196 196"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 98,
    r: 40,
    fill: "url(#a)",
    stroke: "#f8af18",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fbbf24",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 12,
    d: "M98 31.4V6m0 184v-25.4M145.1 51l18-17.9M33 163l18-17.9M51 51 33 33m130.1 130.1-18-18M6 98h25.4M190 98h-25.4"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    additive: "sum",
    attributeName: "transform",
    dur: "6s",
    repeatCount: "indefinite",
    type: "rotate",
    values: "0 98 98; 45 98 98"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "d",
    viewBox: "0 0 350 222"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    stroke: "#e6effc",
    strokeMiterlimit: 10,
    strokeWidth: 6,
    d: "m291 107-2.5.1A83.9 83.9 0 00135.6 43 56 56 0 0051 91a56.6 56.6 0 00.8 9A60 60 0 0063 219l4-.2v.2h224a56 56 0 000-112Z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "e",
    viewBox: "0 0 363 258"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    width: 196,
    height: 196
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    width: 350,
    height: 222,
    transform: "translate(13 36)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 99.5,
    x2: 232.6,
    y1: 30.7,
    y2: 261.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f3f7fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f3f7fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#deeafb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 78,
    x2: 118,
    y1: 63.4,
    y2: 132.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbbf24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fbbf24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f59e0b"
  })))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    width: 363,
    height: 258,
    transform: "translate(68 109)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartlyCloudyDay);
export default __webpack_public_path__ + "static/media/partly-cloudy-day.e206e5214ce343d08aaa456fb2b2e061.svg";
export { ForwardRef as ReactComponent };